function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { authActions } from "../../redux/auth";
import useLocale from "../intl/useLocale";
import { LanguageLoaderContext } from "../intl/LanguageLoaderProvider";
AuthManager.propTypes = {
    children: PropTypes.node.isRequired
};
export default function AuthManager(param) {
    var children = param.children;
    var currentLocale = useLocale();
    var _useState = _sliced_to_array(useState(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), error = _useState1[0], setError = _useState1[1];
    var dispatch = useDispatch();
    var loadNewLanguage = useContext(LanguageLoaderContext);
    var urlParams = new URLSearchParams(window.location.search);
    var myCompanyIdFromQuery = urlParams.get("myCompanyId");
    myCompanyIdFromQuery = myCompanyIdFromQuery ? parseInt(myCompanyIdFromQuery) : null;
    if (error) {
        //* Error boundaries do not catch errors for:
        // Event handlers
        //! Asynchronous code (e.g. setTimeout or requestAnimationFrame callbacks)
        // Server side rendering
        // Errors thrown in the error boundary itself (rather than its children)
        throw error;
    }
    function doLogin() {
        return _doLogin.apply(this, arguments);
    }
    function _doLogin() {
        _doLogin = _async_to_generator(function() {
            var _ref, locale, emailVerifiedAt, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            11,
                            12
                        ]);
                        return [
                            4,
                            dispatch(authActions.getIdentityApi(myCompanyIdFromQuery))
                        ];
                    case 1:
                        _ref = _state.sent(), locale = _ref.locale, emailVerifiedAt = _ref.emailVerifiedAt;
                        if (!emailVerifiedAt) return [
                            3,
                            3
                        ];
                        //? Will get permissions after verifying (onSubmit)
                        return [
                            4,
                            Promise.all([
                                dispatch(authActions.getPermissions()),
                                dispatch(authActions.getSubscriptions()),
                                dispatch(authActions.getPlans())
                            ])
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        if (!(currentLocale !== locale)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            loadNewLanguage(locale)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            12
                        ];
                    case 6:
                        err = _state.sent();
                        console.warn(err);
                        if (!(err.response && err.response.status === 401)) return [
                            3,
                            7
                        ];
                        console.error("Ignored 401 error during login:", err);
                        return [
                            3,
                            10
                        ];
                    case 7:
                        if (!(err.response && err.response.status === 425)) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 1000);
                            })
                        ];
                    case 8:
                        _state.sent();
                        return [
                            2,
                            doLogin()
                        ];
                    case 9:
                        if (err.response && err.response.status === 426) {
                            window.location.reload();
                        } else {
                            console.error("Unexpected error during login:", err);
                            setError(err);
                        }
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return _doLogin.apply(this, arguments);
    }
    useEffect(function() {
        doLogin();
    }, []);
    if (isLoading) {
        return null;
    }
    return children;
}
